import React from "react"
import FormInput from "../../../components/Form/Inputs/FormInput"
import AsyncCreatableTag from "../../../components/Form/Select/AsyncCreatableTag"
import {
  ARTIFACT_TAG_TECHNIQUE,
  ARTIFACT_TAG_CONDITION,
  ARTIFACT_TAG_DEPARTMENT,
} from "../../../api/Definitions"
import Textarea from "../../../components/Form/Inputs/Textarea"
import { Controller } from "react-hook-form"

const ArtifactDetails = () => {
  return (
    <div className="scrollable container">
      <FormInput name="productionDate" label="Production date" />
      <FormInput name="productionPlace" label="Production place" />
      <FormInput name="findspot" label="Findspot" />
      <AsyncCreatableTag
        name="technique"
        group={ARTIFACT_TAG_TECHNIQUE}
        isMulti={true}
        label="Technique"
      />
      <div className="row">
        <div className="col-4">
          <FormInput
            name="depth"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
            label="Depth (cm)"
          />
        </div>
        <div className="col-4">
          <FormInput
            name="height"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
            label="Height (cm)"
          />
        </div>
        <div className="col-4">
          <FormInput
            name="width"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
            label="Width (cm)"
          />
        </div>
      </div>
      <Controller as={Textarea} name="inscriptions" label="Inscriptions" />
      <Controller
        as={Textarea}
        name="curatorComment"
        label="Curator's comment"
      />
      <AsyncCreatableTag
        name="condition"
        group={ARTIFACT_TAG_CONDITION}
        isMulti={false}
        label="Condition"
      />

      <AsyncCreatableTag
        name="department"
        group={ARTIFACT_TAG_DEPARTMENT}
        isMulti={false}
        label="Department"
      />
      <FormInput name="inventoryNumber" label="Inventory number" />
    </div>
  )
}

export default ArtifactDetails
